<template lang="pug">
  div.slits
    figure.slit(v-for="(n, i) in slits",:style="sty(n.pos)")
      <!--img(v-if="cnt === 0",src="/static/front/FS0700S.svg")-->
      <!--img(v-if="cnt === 1",src="/static/front/FS1202M.svg")-->
      <!--img(v-if="cnt === 2",src="/static/front/FS1753J.svg")-->
      <!--img(v-if="cnt === 3",src="/static/front/FS1979L.svg")-->
</template>

<script>
export default {
  name: 'SizeWidth',
  components: {
  },
  data () {
    return {
      cnt: 0,
      slits: []
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    sty (num) {
      let bg;
      this.color = this.sets[this.number].color;
      if (this.color === 1) {
        bg = '#32353a';
      } else {
        bg = '#ffffff';
      }
      return {
        backgroundColor: bg,
        left: this.c2p(num) + 'px'
      };
    },
    update () {
      if (this.sets[this.number] !== undefined) {
        let num = Math.round(this.sets[this.number].size[1] * 10) / 10;
        const isLargeNumber = (element) => Number(element.pos) === Number(num);
        this.cnt = this.slititems.findIndex(isLargeNumber);
        this.slits = this.sets[this.number].slits;
      }
    }
  },
  created () {
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .slits
    position absolute
    left 0
    top 0
    display flex
    z-index 2
    .slit
      width 10px
      height 3px
      background-color #ffffff
      position absolute
      left 0
      top 0
      transform translate(-50%,0)
      box-shadow 1px 1px 3px #00000033
      user-select none
      img
        position absolute
        left 0
        top 0
        width 100%
        height 100%
</style>



// WEBPACK FOOTER //
// src/components/top/Slits.vue